import { postFileNoWatermarkCheck, postFileWithWatermarkCheck } from "../../api/glAxios";
import { GLFile } from "../../types/listing/file";

export async function uploadFile(file:File, checkForWatermarks:boolean):Promise<GLFile | undefined>{
    const fileUploadFunc = checkForWatermarks ? postFileWithWatermarkCheck : postFileNoWatermarkCheck;
    return new Promise((resolve, reject) =>{
        try {
            fileUploadFunc(file, (data: any) => {
                if(!data){
                    reject("Error Uploading");
                }else{ 
                    resolve(data);
                }
            }); 
        } catch (err) {
            reject(err);                
        }
    });
}

export const convertBase64ToFile = (base64string: string, filename: string, fileExtension?: string): File | undefined => {
    const arr = base64string.split(',');

    // Ensure file extension check has a prepended period
    if (fileExtension && fileExtension.indexOf(".") === -1) {
        fileExtension = "." + fileExtension;
    }

    // Ensure the filename has the extension or it could fail upon upload
    if (fileExtension && filename.indexOf(fileExtension) === -1) {
        filename += fileExtension;
    }

    if (arr && arr.length > 0 && arr[0] !== null) {
        const matches = arr[0].match(/:(.*?);/);
        let mime: string;

        if (matches && matches[1]) {
            mime = matches[1]; // Use the MIME type from the base64 string
        } else {
            // Fallback to a default MIME type based on the file extension
            mime = fileExtension ? getMimeTypeFromExtension(fileExtension) : 'application/octet-stream';
        }

        // Handle the case where MIME type could be binary/octet-stream
        if (mime === 'binary/octet-stream' && fileExtension) {
            mime = getMimeTypeFromExtension(fileExtension); // Get the correct MIME type from the extension
        }

        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    return undefined;
}

// Function to get MIME type based on file extension
const getMimeTypeFromExtension = (extension: string): string => {
    switch (extension.toLowerCase()) {
        case '.png':
            return 'image/png';
        case '.jpg':
        case '.jpeg':
            return 'image/jpeg';
        case '.gif':
            return 'image/gif';
        case '.pdf':
            return 'application/pdf';
        case '.txt':
            return 'text/plain';
        // Add other extensions and their MIME types as necessary
        default:
            return 'application/octet-stream'; // Default MIME type
    }
}